// scroll service steps
import { ScrollToggle } from "../_Common/ScrollToggle.js"

import { Lead } from "../Lead/Lead.js"
const lead = new Lead()
window.lead = lead

import { Tags } from "../Portfolio/Tags.js"
const tags = new Tags()
window.tags = tags

const header = document.querySelector(".header")
const headerLogo = header.querySelector(".header__logo")
const headerNav = header.querySelector(".header__nav")
const headerRequest = header.querySelector(".header__request")
const footer = document.querySelector(".footer")
const footerLogo = footer.querySelector(".footer__logo")
const footerCopyright = footer.querySelector(".footer__copyright")
const footerPolicy = footer.querySelector(".footer__policy")

// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
}

if (isTouchDevice()) {
	$("body").removeClass("des")
	$("body").addClass("mob")
} else {
	$("body").removeClass("mob")
	$("body").addClass("des")
}


// Header
$(".header__nav-toggler").click(function () {
	$(this).toggleClass("active")
	$(".header__nav-list").toggleClass("active")
})

function setHeaderNavMargin() {
	if ((window.matchMedia("(min-width: 1024px)").matches)) {
		headerNav.style.marginLeft = headerRequest.offsetWidth - headerLogo.offsetWidth + "px"
	} else {
		headerNav.removeAttribute("style")
	}
}
setHeaderNavMargin()

function setFooterCopyrightMargin() {
	if ((window.matchMedia("(min-width: 1024px)").matches)) {
		footerCopyright.style.marginLeft = footerPolicy.offsetWidth - footerLogo.offsetWidth + "px"
	} else {
		footerCopyright.removeAttribute("style")
	}
}
setFooterCopyrightMargin()


// resize
$(window).resize(function () {
	// is touch
	isTouchDevice()

	// Header nav
	if ((window.matchMedia("(min-width: 1024px)").matches) && $(".header__nav-list").hasClass("active")) {
		$(".header__nav-toggler").removeClass("active")
		$(".header__nav-list").removeClass("active")
	}

	setHeaderNavMargin()
	setFooterCopyrightMargin()

	// textarea autoheight
	$(".form__textarea--autoheight").each(function () {
		this.style.height = "auto"
		this.style.height = (this.scrollHeight) + 1 + "px"
	})

	// Portfolio page filter
	if ((window.matchMedia("(min-width: 768px)").matches) && $(".portfolio-page__tags-content").is(":visible")) {
		$(".portfolio-page__tags-content").removeAttr("style")
	}
})


// Document clicks
$(document).click(function (e) {
	if (!(window.matchMedia("(min-width: 1024px)").matches) && $(".header__nav-list").hasClass("active")) {
		let callbackPopup = $(".header__nav-list, .header__nav-toggler")
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__nav-toggler").removeClass("active")
			$(".header__nav-list").removeClass("active")
		}
	}
})


// popups
$(".popup__close, .popup__cancel").click(function (e) {
	$("body").removeClass("no-scroll")
	$(this).closest(".popup").removeClass("active")
})

$(".popup").click(function (e) {
	let callbackPopup = $(".popup__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active")
		$("body").removeClass("no-scroll")
	}
})

$(".header__request, .main__request").click(function () {
	$("body").addClass("no-scroll")
	$(".popup-request").addClass("active")
})


// textarea autoheight
$(".form__textarea--autoheight").each(function () {
	this.style.height = "auto"
	this.style.height = (this.scrollHeight) + 1 + "px"
})

$(".form__textarea--autoheight").on("input", function () {
	this.style.height = "auto"
	this.style.height = (this.scrollHeight) + 1 + "px"
})


// scroll service steps
// class ScrollToggle {
// 	constructor(element) {
// 		this.container = element
// 		this.toggles = this.container.querySelectorAll(".scroll-block__nav-btn")
// 		this.list = this.container.querySelector(".scroll-block__list")
// 		this.listItems = this.list.querySelectorAll(".scroll-block__item")
// 		this.scrollValue = 0
// 	}
// 	init() {
// 		this.toggles.forEach(toggle => {
// 			toggle.addEventListener("mousedown", (e) => {
// 				this.move(e.target)
// 			})
// 			toggle.addEventListener("mouseup", (e) => {
// 				this.stop()
// 			})
// 		})
// 	}
// 	move(target) {
// 		if (target.classList.contains("scroll-block__nav-btn--right")) {
// 			this.interval = setInterval(() => {
// 				this.list.scrollLeft += 2
// 			}, 1)
// 		} else {
// 			this.interval = setInterval(() => {
// 				this.list.ScrollLeft = this.scrollValue
// 				this.list.scrollLeft -= 2
// 			}, 1)
// 		}
// 	}
// 	stop() {
// 		if (this.list.scrollLeft > 0) {
// 			this.scrollValue = this.list.scrollLeft
// 		}
// 		clearInterval(this.interval)
// 	}
// }

document.querySelectorAll(".scroll-block").forEach(el => {
	const scrollToggle = new ScrollToggle(el)
	scrollToggle.init()
})


// Portfolio page filter
$(".portfolio-page__tags-toggler").click(function () {
	$(".portfolio-page__tags-content").slideToggle()
})

// $(".portfolio-page__tags-input").click(function () {
// 	console.log(this)
// 	document.querySelector('.portfolio__table > ul.portfolio__table-list').innerHTML = ''
// })

// tabs
$(".tabs__tab:not(:first-of-type)").hide()
$(".tabs__nav-item:first-of-type .tabs__nav-btn").addClass("active")
$(".tabs__nav-btn").click(function() {
	if(!$(this).hasClass("active")) {
		$(this).parent(".tabs__nav-item").siblings().children(".tabs__nav-btn").removeClass("active")
		$(this).addClass("active")
		$(this).parents(".tabs").find(".tabs__tab").hide()
		$(".tabs__tab").eq($(this).index(".tabs__nav-btn")).fadeIn()
	}
})


// Requisites
$(".contacts__requisites-toggler").click(function () {
	$(".contacts__requisites-content").slideToggle()
})
